import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../../store/global-selectors';
import messages from './messages';

const ServiceText = ({ sellerLabelProviderId }) => {
  const services = useSelector(Global.selectSellerServices);
  const filteredServices = services.filter((service) => service.sellerLabelProviderId === sellerLabelProviderId);
  const numberOfServices = filteredServices.length;
  const numberOfVisibleServices = filteredServices.filter((service) => !service.isHidden).length;

  if (numberOfVisibleServices === 0) {
    return <FormattedMessage {...messages.noServices} />;
  }

  return (
    <FormattedMessage
      {...messages.servicesVisibleText}
      values={{
        numberOfServices,
        numberOfVisibleServices,
      }}
    />
  );
};

ServiceText.propTypes = {
  sellerLabelProviderId: PropTypes.string.isRequired,
};

export default ServiceText;
